/**
 * Emit hosts for the `assistant-view` analytics group — 1 function
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { type AssistantPanelActionEventProps } from '@/models/analytics/features/assistant-view';

export function assistantPanelAction(props: AssistantPanelActionEventProps) {
  track({
    event_name: TrackingEventName.AssistantPanelAction,
    props,
  });
}
